import { Box, StatusLabel, StatusLabelTypes } from '@factorialco/deprecated-design-system'
import { ExpensesEntitiesExpensableStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  status: ExpensesEntitiesExpensableStatusEnum
}

const statusLabelType = (status: string): StatusLabelTypes => {
  switch (status) {
    case 'pending':
    case 'draft':
      return 'neutral'
    case 'manual':
    case 'automatic':
    case 'in_progress':
    case 'changes_requested':
    case 'sent_to_pay':
    case 'in_payroll':
    case 'approved':
      return 'info'
    case 'rejected':
    case 'reversed':
      return 'critical'
    case 'paid':
      return 'positive'
    default:
      return 'neutral'
  }
}

const getStatusLabel = (status: ExpensesEntitiesExpensableStatusEnum): string => {
  const statuses: Record<string, string> = {
    ['reversed']: i18n.t('expenses_v2.expense.status.reversed'),
    ['draft']: i18n.t('expenses_v2.expense.status.draft'),
    ['approved']: i18n.t('expenses_v2.expense.status.approved'),
    ['pending']: i18n.t('expenses_v2.expense.status.pending'),
    ['rejected']: i18n.t('expenses_v2.expense.status.rejected'),
    ['in_payroll']: i18n.t('expenses_v2.expense.status.inPayroll'),
    ['sent_to_pay']: i18n.t('expenses_v2.expense.status.sentToPay'),
    ['paid']: i18n.t('expenses_v2.expense.status.paid'),
    ['changes_requested']: i18n.t('expenses_v2.expense.status.changesRequested'),
  }

  return statuses[status] ?? ''
}

export const Status = ({ status }: Props) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <StatusLabel type={statusLabelType(status)}>{getStatusLabel(status)}</StatusLabel>
    </Box>
  )
}
